export const FETCH_RX_MERCHANTS = 'FETCH_RX_MERCHANTS';
export const FETCH_RX_BANKING_ACCOUNTS = 'FETCH_RX_BANKING_ACCOUNTS';
export const FETCH_RX_INTEGRATION_DETAILS = 'FETCH_RX_INTEGRATION_DETAILS';